import { ItemMenu } from "@/app/common/types/commonTypes";

// Lazy load menu items to prevent circular dependency issues in production builds
// The menus are loaded asynchronously to break the circular dependency chain
let cachedMenuItems: ItemMenu[] | null = null;

async function loadMenuItems(): Promise<ItemMenu[]> {
  if (cachedMenuItems) {
    return cachedMenuItems;
  }

  // Dynamically import menu modules to break circular dependencies
  const { registrationMenus } = await import("@/app/registration/routes/registrationMenus");
  const { theatreMenus } = await import("@/app/theatre/routes/theatreMenus");
  const { pharmacyMenus } = await import("@/app/pharmacy/routes/pharmacyMenus");
  const { doctorMenus } = await import("@/app/doctors/routes/doctorMenus");
  // const { inventoryMenus } = await import("@/app/inventory/routes/inventoryMenus"); // Temporarily hidden

  cachedMenuItems = [
    ...registrationMenus,
    ...doctorMenus,
    // ...inventoryMenus, // Temporarily hidden - will enable in future
    ...theatreMenus,
    ...pharmacyMenus,

    // Temporarily hidden modules - uncomment to show
    // ...financeMenus,
    // ...clinicalMenus,
    // ...radiologyMenus,
    // ...nurseMenus,
    // {
    //   itemId: uuidv4(),
    //   icon: ImLab,
    //   title: homePaths.laboratory.title,
    //   route: homePaths.laboratory.path,
    //   tag: homePaths.laboratory.tag,
    // },
    // {
    //   itemId: uuidv4(),
    //   icon: FaTooth,
    //   title: homePaths.dental.title,
    //   route: homePaths.dental.path,
    //   tag: homePaths.dental.tag,
    // },
    // {
    //   itemId: uuidv4(),
    //   icon: BsFillHeartPulseFill,
    //   title: homePaths.cardiology.title,
    //   route: homePaths.cardiology.path,
    //   tag: homePaths.cardiology.tag,
    //   spacing: true,
    // },
    // {
    //   itemId: uuidv4(),
    //   icon: BsFillOpticalAudioFill,
    //   title: homePaths.optical.title,
    //   route: homePaths.optical.path,
    //   tag: homePaths.optical.tag,
    // },
    // ...reportMenus,
    // ...integrationMenus,
    // ...toolMenus,
    // ...communicationMenus,
  ];

  return cachedMenuItems;
}

// Export a function to get menu items instead of direct export
export { loadMenuItems };

// For backward compatibility, provide a getter
export const getMenuItems = (): Promise<ItemMenu[]> => loadMenuItems();
